// removed by extract-text-webpack-plugin
module.exports = {"container":"src-components-PatientGroups-Edit-__patient-names-list__container--pv1cM","patient":"src-components-PatientGroups-Edit-__patient-names-list__patient--3Go8B"};


//////////////////
// WEBPACK FOOTER
// ./src/components/PatientGroups/Edit/patient-names-list.css
// module id = 1989
// module chunks = 0